import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

export interface UserLocationBadgeItem {
  warehouseId: string;
  warehouseCode: string;
  warehouseName: string;
  warehouseType: string;
}

interface UserLocationBadgesProps {
  locations: UserLocationBadgeItem[];
  maxVisible?: number;
}

function locationTitle(loc: UserLocationBadgeItem): string {
  return `${loc.warehouseType}: ${loc.warehouseName} (${loc.warehouseCode})`;
}

export function UserLocationBadges({
  locations,
  maxVisible = 2,
}: UserLocationBadgesProps) {
  if (locations.length === 0) {
    return null;
  }

  const visible = locations.slice(0, maxVisible);
  const hiddenCount = locations.length - visible.length;

  return (
    <div className="flex max-w-xs items-center gap-1 overflow-hidden">
      {visible.map((loc) => (
        <Badge
          key={loc.warehouseId}
          variant="outline"
          className="max-w-[9rem] shrink truncate font-normal"
          title={locationTitle(loc)}
        >
          {loc.warehouseName}
        </Badge>
      ))}
      {hiddenCount > 0 && (
        <Popover>
          <PopoverTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-6 shrink-0 px-1.5 text-xs text-muted-foreground hover:text-foreground"
            >
              +{hiddenCount} more
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-80 p-3" align="start">
            <p className="mb-2 text-xs font-medium text-muted-foreground">
              {locations.length} assigned location{locations.length === 1 ? '' : 's'}
            </p>
            <div className="flex max-h-52 flex-wrap gap-1 overflow-y-auto">
              {locations.map((loc) => (
                <Badge
                  key={loc.warehouseId}
                  variant="outline"
                  className="max-w-full truncate font-normal"
                  title={locationTitle(loc)}
                >
                  {loc.warehouseName}
                </Badge>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
}
